"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const EmailRegistration_1 = __importDefault(require("@/components/organisms/steps/EmailRegistration"));
const PasswordAndCodeRegistration_1 = __importDefault(require("@/components/organisms/steps/PasswordAndCodeRegistration"));
const UserRegistrationContext_1 = require("@/context/UserRegistrationContext");
const UserInfo_1 = __importDefault(require("@/components/organisms/steps/UserInfo/UserInfo"));
const Industry_1 = __importDefault(require("@/components/organisms/steps/Industry"));
const Newsletter_1 = __importDefault(require("@/components/organisms/steps/Newsletter"));
const Success_1 = __importDefault(require("@/components/organisms/steps/Success"));
const ProgressBar_1 = __importDefault(require("@/components/molecules/ProgressBar"));
const Shared_1 = require("@/components/styled-controls/Shared");
const useApiService_1 = require("@/api/useApiService");
const UserRegistration = () => {
    const { step, appProps, userData, setUserData } = (0, UserRegistrationContext_1.useUserRegistration)();
    const { userService } = (0, useApiService_1.useApiService)();
    (0, react_1.useEffect)(() => {
        if (appProps.salesforceProxyApiUrl && !userData.availableNewsletters) {
            userService
                .fetchNewsletters(appProps.salesforceProxyApiUrl)
                .then((newsletters) => {
                setUserData((prev) => ({ ...prev, availableNewsletters: newsletters }));
            })
                .catch((err) => {
                console.error('Failed to fetch newsletters:', err);
            });
        }
    }, []);
    const stepsMap = {
        email: react_1.default.createElement(EmailRegistration_1.default, null),
        passwordAndCode: react_1.default.createElement(PasswordAndCodeRegistration_1.default, null),
        basicInfo: react_1.default.createElement(UserInfo_1.default, null),
        industry: react_1.default.createElement(Industry_1.default, null),
        newsletter: react_1.default.createElement(Newsletter_1.default, null),
        success: react_1.default.createElement(Success_1.default, null),
    };
    /**
     * Represents a map that associates progress steps with their corresponding numbers.
     * Progress bar is not needed for the first 2 screens.
     */
    const progressMap = {
        basicInfo: 1,
        industry: 2,
        newsletter: 3,
        success: 4,
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Shared_1.ScrollLockForBottomPlacement, { "$placement": appProps.placement }),
        react_1.default.createElement(Shared_1.UserRegistrationContainer, { "$placement": appProps.placement, "$registrationSource": appProps.registrationSource },
            react_1.default.createElement(Shared_1.StepContainer, null,
                progressMap[step] ? react_1.default.createElement(ProgressBar_1.default, { progress: progressMap[step] }) : null,
                stepsMap[step]))));
};
exports.default = UserRegistration;
